exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._26NLp5rFi4Dm1Ge8e8CeOY{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex}._21oX3Fa2g_RO6g_doIYpio{color:#f5a623}._21oX3Fa2g_RO6g_doIYpio+._21oX3Fa2g_RO6g_doIYpio{margin-left:.35714rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ScoreStar": "_26NLp5rFi4Dm1Ge8e8CeOY",
	"ScoreStar_starIcon": "_21oX3Fa2g_RO6g_doIYpio"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/ProgressReport/StudentReportView/ScoreStar/style.postcss
// module id = 1488
// module chunks = 0